export default "__VITE_ASSET__Ck1UH09e__"